import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    width?: number;
    height?: number;
    fill?: string;
};

export const ElevatorIcon = ({ width = 80, height = 80, fill = 'currentColor', ...props }: Props) => {
    const { scaleWidthPixel, scaleHeightPixel } = useScreenSize();
    return (
        <svg width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M39.0717 63.0295H18.0093V15.4854H59.1316V63.0295H43.0509" stroke={fill} strokeWidth="2" />
            <path d="M38.5701 20.1152L38.5703 64.0217" stroke={fill} strokeWidth="2" />
            <path d="M66.793 36.6396L71.0413 32.5361L75 36.6396" stroke={fill} strokeWidth="2" />
            <path d="M75 44.8467L70.7516 48.9502L66.793 44.8467" stroke={fill} strokeWidth="2" />
        </svg>
    );
};
